module.exports = __webpack_public_path__ + "static/media/pavni.809ae53d.jfif";